<!-- @format -->
<template>
	<div>
		<van-cell
			:key="globalStore.userInfo?.user?.id"
			:title="`${globalStore.userInfo?.user?.userName || globalStore.userInfo?.user?.account || ''}`"
			value=""
			is-link
			@click="onClickMenuItem(item)"
		>
			<template #icon>
				<div class="user-icon">
					<van-image
						:src="
							globalStore.userInfo?.user?.avatar ||
							getEnvUrlByUrl('power-front-base/frontend/images/default/user-default.png')
						"
					/>
				</div>
			</template>
			<template #label>
				<div class="user-label">
					<div>{{ globalStore.userInfo?.user?.dept?.deptName || globalStore.userInfo?.org?.name || '' }}</div>
					<template v-if="globalStore.userInfo?.user?.userPosition">
						<van-tag type="primary">{{ globalStore.userInfo?.user?.userPosition || '' }}</van-tag>
					</template>
					<template v-else-if="globalStore.userInfo?.positions?.length > 0">
						<van-tag v-for="item in globalStore.userInfo?.positions" :key="item.id" type="primary">
							{{ item.name || '' }}
						</van-tag>
					</template>
				</div>
			</template>
		</van-cell>
	</div>
</template>

<script lang="ts" setup>
	import { getQueryObject } from '@power/utils';
	import { MenuItem, useGlobalStoreWithOut, getEnvUrlByUrl } from '@power/runtime-vue3';
	import { onClickMenuItem as onClickMenuItem2 } from '../pcp-mo-menu';
	import { useMoGlobalStoreWithOut } from '@/store/modules/moglobal';

	const moglobalStore = useMoGlobalStoreWithOut();
	const globalStore = useGlobalStoreWithOut();
	const router = useRouter();
	interface Props {
		item?: MenuItem; // 所有菜单
	}
	withDefaults(defineProps<Props>(), {});

	const onClickMenuItem = (item) => {
		// console.log('onClickMenuItem', item);
		clickMenuItem(item);
	};
	const clickMenuItem = (item) => {
		// console.log('clickMenuItem.item', item);
		const url = onClickMenuItem2(item);
		const query = getQueryObject(url);
		router.push({
			path: url,
			query: {
				...query,
				navigationBarTitle: item.name,
			},
		});
		moglobalStore.setNavigationBar({
			title: item.name,
			leftArrow: true,
		});
		return;
	};
</script>

<style scoped lang="scss">
	.user-icon {
		display: flex;
		align-items: center;
		margin-right: 6px;

		.van-image {
			width: 46px;
			height: 46px;
		}
	}
</style>
